/**
 * Possible sources for custom tags
 */
export var TagSource;
(function (TagSource) {
    TagSource["StaticUrl"] = "static-url";
    TagSource["Assets"] = "assets";
})(TagSource || (TagSource = {}));
//# sourceMappingURL=CustomTag.js.map